module.exports = __webpack_public_path__ + "img/import-from-db.b757337e.svg";